import { Component, OnInit, Input, OnChanges, OnDestroy, Inject } from '@angular/core';
import { tvdData, TvdMetricDisplayData } from '../../types/tvd-types';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { Subscription } from 'rxjs';
import { FiltersService } from 'src/app/core/services/filters.service';
import { TVDService } from '../../services/tvd.service';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';
import { UIPreferencesService } from 'src/app/core/services/ui-preferences.service';

@Component({
    selector: 'tvd-overall',
    templateUrl: './tvd-overall.component.html',
    styleUrls: ['./tvd-overall.component.scss', '../../styles/tvd-repeat-styles.scss'],
    standalone: false
})
export class TvdOverallComponent implements OnInit, OnChanges, OnDestroy {
  filters: ContractModel | undefined;
  private filtersSubscription: Subscription | undefined;
  private currencySubscription: Subscription | undefined;
  private displayInRoundedNumberSubscription: Subscription | undefined;

  @Input() id: string | undefined;
  @Input() value: tvdData | undefined;
  currencyCode: string = "USD";
  displayInRoundedNumber: boolean = true;

  get totalValueDelivered(): TvdMetricDisplayData {
    const isMonetaryContributionModified = Number((this.value?.modifiedMonetaryContribution || '0').replace(/,/g, '')) > 0;
    const isValueContributionModified = Number((this.value?.modifiedValueContribution || '0').replace(/,/g, '')) > 0;

    return {
      currentMonetaryContribution: isMonetaryContributionModified
        ? this.value?.modifiedMonetaryContribution || '0'
        : this.value?.monetaryContribution || '0',
      defaultMonetaryContribution: isMonetaryContributionModified
        ? this.value?.monetaryContribution || '0'
        : undefined,
      currentValueContribution: isValueContributionModified
        ? this.value?.modifiedValueContribution || '0'
        : this.value?.valueContribution || '0',
      defaultValueContribution: isValueContributionModified
        ? this.value?.valueContribution || '0'
        : undefined,
      isMonetaryContributionModified,
      isValueContributionModified
    };
  }

  constructor(
    private filtersService: FiltersService,
    private tvdService: TVDService,
    private currencyUomService: CurrencyUomService,
    private uiPreferencesService: UIPreferencesService
  ) { }

  ngOnInit(): void {
    this.filtersSubscription = this.filtersService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.displayInRoundedNumberSubscription = this.uiPreferencesService.displayRoundedValuesObservable.subscribe(f => this.displayInRoundedNumber = f);
    if(this.filters) {
      this.currencyCode = this.currencyUomService.getCurrencyCode();
    }

    this.currencySubscription = this.currencyUomService.displayedCurrency$.subscribe(() => {
      this.currencyCode = this.currencyUomService.getCurrencyCode();
    });

    this.tvdService.totalTotalValueDeliveredObservable.subscribe(tvd => {
      if(tvd) {
        this.value = tvd;
      }
    });
  }

  ngOnChanges() {

  }

  ngOnDestroy(): void {
    this.filtersSubscription?.unsubscribe();
    this.currencySubscription?.unsubscribe();
    this.displayInRoundedNumberSubscription?.unsubscribe();
  }
}
